// extracted by mini-css-extract-plugin
export default {"imageWrapper":"SavedSearch_imageWrapper__J0Oxp","savedSearchActionsWrapper":"SavedSearch_savedSearchActionsWrapper__BdbcA","savedRegionHeader":"SavedSearch_savedRegionHeader__NRLeg"};